import { lcp } from './longest-common-sequence';

/**
 * Clusters arrays of tokens by their longest common prefix.
 * Each cluster contains arrays that share a prefix longer than the threshold.
 */
export function clusterByLCP(listOfTokenArrays: string[][], threshold = 0): string[][][] {
  const clusters: string[][][] = [];
  let idx = 0;

  while (idx < listOfTokenArrays.length) {
    const cluster: string[][] = [listOfTokenArrays[idx]];
    let currentPrefix = listOfTokenArrays[idx];
    idx += 1;

    while (idx < listOfTokenArrays.length) {
      const newPrefix = lcp(currentPrefix, listOfTokenArrays[idx]);

      if (newPrefix.length <= threshold) {
        break;
      }

      cluster.push(listOfTokenArrays[idx]);
      currentPrefix = newPrefix;
      idx += 1;
    }

    clusters.push(cluster);
  }

  return clusters;
}
